import { GET_EQUIPMENT_ASSETS } from './fetchEquipmentAssets';

import { UPLOAD_EQUIPMENT_ASSETS } from './uploadEquipmentImages';
import { REMOVE_EQUIPMENT_ASSET } from './removeEquipmentAsset';

export const equipmentImagesApi = {
  uploadAssets: UPLOAD_EQUIPMENT_ASSETS,
  removeAssets: REMOVE_EQUIPMENT_ASSET,
  fetchAssets: GET_EQUIPMENT_ASSETS,
};

export * from './types';
export * from './schemas';
export * from './useEquipmentAssets';
